import { Box, MenuItem, Select } from '@mui/material';

export const ROWS_PER_PAGE_OPTIONS = [10, 25, 50, 100] as const;
export type RowsPerPage = (typeof ROWS_PER_PAGE_OPTIONS)[number];
export const DEFAULT_ROWS_PER_PAGE: RowsPerPage = 10;

export function isRowsPerPage(value: unknown): value is RowsPerPage {
  return (ROWS_PER_PAGE_OPTIONS as readonly unknown[]).includes(value);
}

type Tokens = { font: string; muted: string; ink: string };

export function RowsPerPageSelect({
  value,
  onChange,
  tokens,
}: {
  value: RowsPerPage;
  onChange: (value: RowsPerPage) => void;
  tokens: Tokens;
}) {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
      <Box
        component="span"
        sx={{ fontFamily: tokens.font, fontSize: 12, fontWeight: 500, lineHeight: '16px', color: tokens.muted }}
      >
        Rows per page:
      </Box>
      <Select
        size="small"
        variant="standard"
        disableUnderline
        value={value}
        onChange={(event) => {
          const next = Number(event.target.value);
          if (isRowsPerPage(next)) onChange(next);
        }}
        inputProps={{ 'aria-label': 'Rows per page' }}
        sx={{
          fontFamily: tokens.font,
          fontSize: 12,
          lineHeight: 1.66,
          color: tokens.ink,
          '& .MuiSelect-select': { py: '4px', pl: '4px', pr: '24px !important' },
        }}
      >
        {ROWS_PER_PAGE_OPTIONS.map((option) => (
          <MenuItem key={option} value={option} sx={{ fontFamily: tokens.font, fontSize: 14 }}>
            {option}
          </MenuItem>
        ))}
      </Select>
    </Box>
  );
}
